<script>
    // Columns is a strange name for this which seems more like it should be called
    // something like a panel, but this is how the API lists it so we're keeping
    // that name for now.
    
    import ElementPanel from "./ElementPanel.svelte";
    import ElementTable from "./ElementTable.svelte";
    import ElementText from "./ElementText.svelte";
    import ElementChart from "./ElementChart.svelte";
    
    export let columnData;

    // console.log('Column columnData', columnData);
</script>

<div class="column width-{columnData.width}" 
    style="grid-column: span {columnData.width};"
    >
    {#each columnData.elements as element}
        {#if element.type == 'panel'}
            <ElementPanel
                elementData = {element}
            />
        {/if}
        {#if element.type == 'text'}
            <ElementText
                elementData = {element}
            />
        {/if}
        {#if element.type == 'table'}
            <ElementTable
                elementData = {element}
            />
        {/if}
        {#if element.type == 'chart'}
            <ElementChart
                elementData = {element}
            />
        {/if}
    {/each}
</div>

<style>

</style>